$(document).mouseup(function (e) {
    var container = $('#menu');
    var clicker = $('.open_menu');
    if (!container.is(e.target) && !clicker.is(e.target) && container.has(e.target).length === 0) {
        container.hide();
    }
});

$(document).mouseup(function (e) {
    var container = $('.notification-all');
    var clicker = $('.notification_icon');
    if (!container.is(e.target) && !clicker.is(e.target) && container.has(e.target).length === 0) {
        container.hide();
    }
});

$(document).ready(function () {
    // Do not run code if element does not exist, user is not logged in
    if (!$('.js-notification').length) return;
    var url = '/requests/notification.php?domain_id=' + domain_id;

    $('.js-notification').on('click', function () {
        if (window.platform === 'gp') {
            $('body').addClass('noscroll');
        }
        $.ajax({
            async: true,
            url: url,
            type: 'GET',
            success: function (html) {
                //$(".js-notification span").remove();
                $('.js-notification-show').html(html);
                $('.js-notification-show').toggle();
            },
        });
        return false;
    });

    $(document).on('click', '.js-notification-mark-unread, #mark_read', function (e) {
        $.ajax({
            async: true,
            url: url,
            type: 'GET',
            data: {
                notificationUnread: 1,
            },
            success: function (html) {
                $('.notification-item').removeClass('notification-unread');
                $('.notification-item').addClass('seen');
                $('.notification_icon.js-notification span').remove();
            },
        });
        return false;
    });

    $(document).on('click', '.notification-item', function () {
        var commentID = this.hash;
        var commentDiv = $(commentID);

        if (window.location.hash == commentID) {
            // console.log('yes');
            $('body').removeClass('noscroll');
            $('.js-notification-show').toggle();
            $('#login .profile-menu').removeClass('active');

            if (commentDiv) {
                var scrollTop = {
                    scrollTop: commentDiv.offset().top - 100,
                };
                $('html, body').animate(scrollTop, 'slow');
            }
        } else {
            // console.log('Nope');
            // console.log(window.location.hash, commentID);
        }
    });

    $(document).on('click', '.js-notification-unread', function (e) {
        var userNotificationID = $(this).data('notification-id');
        $.ajax({
            async: true,
            url: url,
            type: 'GET',
            data: {
                userNotificationID: userNotificationID,
            },
            success: function (html) {
                $('a[notification-id="' + userNotificationID + '"]').removeClass('.notification-unread');
            },
        });
    });

    $(document).on('click', '.js-notification-readmore', function (e) {
        var userNotificationDate = $(this).data('user-notification-date');
        $.ajax({
            async: true,
            url: url,
            type: 'GET',
            data: {
                userNotificationDate: userNotificationDate,
            },
            success: function (html) {
                var className;
                if (window.platform === 'gp') {
                    className = '.js-notification-show .notifications-wrapper .notification-context';
                } else {
                    className = '.js-notification-show';
                }

                $('.js-notification-read-more').remove();
                $(className).append(html);
            },
        });
        return false;
    });

    $.ajax({
        async: true,
        url: url,
        type: 'GET',
        data: {
            notificationCheck: 1,
        },
        success: function (content) {
            if (content > 0) {
                $('.js-notification').text(content).addClass('notification_icon');
                $('.profile-notifications').append("<span class='tag breaking'>" + content + '</span>');

                if (window.platform === 'gp') {
                    $('#login').prepend('<span class="dot"></span>');
                }
            }
        },
    });
});
